import { type SliderRange } from '@/core/components/CustomSlider/CustomSlider';
import { buildRangePayload, type RangePayload } from '@/core/components/RangePayload/RangePayload';

export const INTERACTIONS_MIN = 0;
export const INTERACTIONS_MAX = 5_000_000;

export interface InteractionsData {
  likes: SliderRange;
  shares: SliderRange;
  views: SliderRange;
  comments: SliderRange;
}

export const createDefaultInteractionsData = (): InteractionsData => ({
  likes: [INTERACTIONS_MIN, INTERACTIONS_MAX],
  shares: [INTERACTIONS_MIN, INTERACTIONS_MAX],
  views: [INTERACTIONS_MIN, INTERACTIONS_MAX],
  comments: [INTERACTIONS_MIN, INTERACTIONS_MAX],
});

export const buildInteractionRangePayload = (range: SliderRange): RangePayload | undefined =>
  buildRangePayload(range, INTERACTIONS_MIN, INTERACTIONS_MAX);

export const isInteractionRangeFiltered = (range: SliderRange): boolean =>
  buildInteractionRangePayload(range) !== undefined;

export const buildInteractionsPayload = (data: InteractionsData): Record<string, RangePayload> => {
  const payload: Record<string, RangePayload> = {};

  (Object.keys(data) as Array<keyof InteractionsData>).forEach((key) => {
    const rangePayload = buildInteractionRangePayload(data[key]);
    if (rangePayload) payload[key] = rangePayload;
  });

  return payload;
};